<script lang="ts">
  import * as _ from "lodash";
  import DiscoveryPanel from "@shared/svelte/DiscoveryPanel/DiscoveryPanel.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import PageWrapper from "@retailer/svelte/Shared/PageWrapper.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { onMount } from "svelte";
  import ActionRequired from "../Components/ActionRequired.svelte";
  import StreamlinedAOOActionRequired from "../Components/StreamlinedAOOActionRequired.svelte";
  import OrderSuccess from "../Components/OrderSuccess.svelte";
  import { updateManualActionRequired } from "@retailer/svelte/Shared/OrderHelpers";
  import RetailerDistributorStore from "@retailer/svelte/stores/RetailerDistributorStore";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  import type { OrderGroup } from "@shared/types/OrderGroup";
  import type { RetailerType } from "@shared/types/Retailer";
  import type { RetailerOrder } from "@shared/types/Order";
  import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";

  export let order: OrderGroup;
  export let retailer: RetailerType;

  const updateOrder = async (orderGroupOrder: RetailerOrder) => {
    const updatedOrder = (await updateManualActionRequired(orderGroupOrder, true)) as RetailerOrder;
    const orderIdx = _.findIndex(order.orders, o => o && o.id === updatedOrder.id);
    order.orders.splice(orderIdx, 1, updatedOrder);
    order = order;
  };

  let discoveryPanelConfig = [];
  let newOrderReceivedWithCcRollout: string = null;

  onMount(() => {
    HttpPromise({
      method: "GET",
      url: "/api/retailer/discovery_panel/discovery_config",
      data: { page_name: "order_confirmation", page_value: null },
    }).then(
      response => (discoveryPanelConfig = response),
      _error => (discoveryPanelConfig = []),
    );
  });

  const setActionCompleted = () => {
    requiresAction = false;
  };

  $: retailerDistributors = $RetailerDistributorStore;
  $: requiresAction = order.orders.some(
    order =>
      order.manual_order_action_required &&
      retailerDistributors.find(rd => rd.distributor.id === order.distributor.id)?.is_aoo_enabled,
  );

  $: showStreamlinedAOOActionRequired =
    stagedRolloutCheck("disco__aoo_streamlined_flow") && $CurrentRetailerStore.aoo_streamlined_flow;
  $: aooDistributors = retailerDistributors.filter(
    rd =>
      rd.is_aoo_enabled && order.orders.some(order => rd.distributor.id === order.distributor.id),
  );
</script>

<PageWrapper let:mobileMode>
  <FizzStyles
    extraClasses={requiresAction && showStreamlinedAOOActionRequired
      ? "background-grayLight"
      : "background-white"}
  >
    <section class="order-success">
      <div class="order-success-wrapper fizz-inset-square-16">
        {#if requiresAction}
          {#if showStreamlinedAOOActionRequired}
            <StreamlinedAOOActionRequired
              orderGroup={order}
              {aooDistributors}
              {setActionCompleted}
            />
          {:else}
            <ActionRequired
              orderGroup={order}
              {retailer}
              {setActionCompleted}
              on:orderUpdated={e => updateOrder(e.detail.order)}
            />
          {/if}
        {:else}
          <OrderSuccess
            orderGroup={order}
            {retailer}
            {newOrderReceivedWithCcRollout}
            {showStreamlinedAOOActionRequired}
          />
          <DiscoveryPanel
            bind:configuration={discoveryPanelConfig}
            pageName={"order_confirmation"}
            {mobileMode}
          />
        {/if}
      </div>
    </section>
  </FizzStyles>
</PageWrapper>
